import $ from 'jquery';
import { api } from 'JIX/utils.js';
import { checkLogin, LoginResult } from 'JIX/utils/login.js';

async function save_result() {
    const rid = window.Stash["talenttest/save"].rid;

    let result = api("POST", "/talenttest/save", {
        rid
    }).then(
        () => {
            $("#save-success-modal").modal();
            return true;
        },
        (error) => {
            $("#save-error-modal .modal-body").html(error.json.errors[0].error_message);
            $("#save-error-modal").modal();
            return false;
        }
    );

    if (await result) {
        $(".save-button").each(function() {
            $(this).prop("disabled", true);
            $(this).text("Gemt");
        });
    }
}

$('.save-button').on('click', async () => {
    const loginRes = await checkLogin();
    if (loginRes !== LoginResult.ABORTED) {
        save_result();
    }
});
